import React, { Component } from "react";
import { default as WSlider } from "@mui/material/Slider";

class Slider extends Component {
  render() {
    return <WSlider {...this.props} />;
  }
}

export default Slider;
